class GraphHelper {
  jumpToRecent (logChartVue, toDatetimeUnixTime = undefined) {
    if (isNaN(toDatetimeUnixTime)) {
      toDatetimeUnixTime = Math.floor(Date.now() / 1000)
      toDatetimeUnixTime = toDatetimeUnixTime - (toDatetimeUnixTime % (15 * 60))
    }
    // グラフ描画のレンジを設定しておく
    const now = toDatetimeUnixTime
    const rangeOffsets = this.getRangePeriodOffsets(logChartVue, true)
    const rangeEnd = now - (now % logChartVue.periodTime)
    logChartVue.range.start = rangeEnd - (logChartVue.periodTime * rangeOffsets.toStart)
    logChartVue.range.end = rangeEnd

    // 日付設定フォームにレンジのTOを設定
    logChartVue.toDatetimeUnixTime = toDatetimeUnixTime
    this.resetDataZoomToolBox(logChartVue)
    logChartVue.reload()
  }
  // APIの引数from,toの範囲外のデータの切り詰め
  omitOutOfRangeFromToData (logChartVue, option) {
    // APIの引数fromより古い
    logChartVue.outOfFromTimestamp = option.xAxis.data[0] || null
    if (logChartVue.outOfFromTimestamp && logChartVue.outOfFromTimestamp < logChartVue.from) {
      option.series.forEach((one, index) => {
        logChartVue.outOfFromSeriesData[index] = one.data[0]
        one.data.splice(0, 1)
      })
      option.xAxis.data.splice(0, 1)
    }
    if (logChartVue.outOfFromSeriesData.length === 0) {
      logChartVue.outOfFromTimestamp = null
    }
    // APIの引数toより新しい
    const lastTimestampIndex = option.xAxis.data.length - 1
    logChartVue.outOfToTimestamp = option.xAxis.data[lastTimestampIndex] || null
    if (logChartVue.outOfToTimestamp && logChartVue.outOfToTimestamp > logChartVue.to) {
      let isNotNullOutOfTo = false
      option.series.forEach((one, index) => {
        if (one.data[lastTimestampIndex] !== null) {
          isNotNullOutOfTo = true
          return
        }
      })
      option.series.forEach((one, index) => {
        if (isNotNullOutOfTo) {
          logChartVue.outOfToSeriesData[index] = one.data[lastTimestampIndex]
        }
        one.data.splice(lastTimestampIndex, 1)
      })
      option.xAxis.data.splice(lastTimestampIndex)
    }
    if (logChartVue.outOfToSeriesData.length === 0) {
      logChartVue.outOfToTimestamp = null
    }
    // この時点でデータを一旦退避
    logChartVue.xAxisDatas = JSON.parse(JSON.stringify(option.xAxis.data))
    option.series.forEach((one, index) => {
      logChartVue.seriesDatas[index] = JSON.parse(JSON.stringify(one))
    })

    return option
  }
  // option.dataZoom[0]の切り詰め
  fixOptionDataZoomRange (logChartVue, option) {
    const rangeStart = Number(option.dataZoom[0].startValue)
    const optionXAxisStart = option.xAxis.data[0]
    const rangeEnd = Number(option.dataZoom[0].endValue)
    const optionXAxisEnd = option.xAxis.data[option.xAxis.data.length - 1]
    let viewRangeStartIndex = -1
    let viewRangeEndIndex = -1
    // APIで受けた日時の先頭が範囲設定のstartのあとの場合はAPIで受けた日時の先頭を設定
    if (rangeStart >= optionXAxisStart) {
      viewRangeStartIndex = option.xAxis.data.indexOf(rangeStart)
    }
    if (viewRangeStartIndex === -1) {
      for (let index = 0; index < option.xAxis.data.length; index++) {
        const element = option.xAxis.data[index]
        if (element > rangeStart) {
          viewRangeStartIndex = index > 0 ? index - 1 : 0
          break
        }
      }
    }
    // APIで受けた日時の末尾が範囲設定のendの前の場合はAPIで受けた日時の末尾を設定
    if (rangeEnd <= optionXAxisEnd) {
      viewRangeEndIndex = option.xAxis.data.indexOf(rangeEnd)
    }
    if (viewRangeEndIndex === -1) {
      for (let index = option.xAxis.data.length - 1; index >= 0; index--) {
        const element = option.xAxis.data[index]
        if (element < rangeEnd) {
          viewRangeEndIndex = index < option.xAxis.data.length - 1 ? index + 1 : option.xAxis.data.length - 1
          break
        }
      }
    }
    // 範囲指定が12プロット分なら12プロット表示できるよう範囲を広げる
    if (rangeEnd - rangeStart >= logChartVue.periodTime * 12) {
      if (viewRangeEndIndex - viewRangeStartIndex < 12) {
        // endを広げる
        if (viewRangeStartIndex + 12 >= option.xAxis.data.length) {
          viewRangeEndIndex = option.xAxis.data.length - 1
        } else {
          viewRangeEndIndex = viewRangeStartIndex + 12
        }
      }
      if (viewRangeEndIndex - viewRangeStartIndex < 12) {
        // startを広げる
        if (viewRangeEndIndex - 12 < 0) {
          viewRangeStartIndex = 0
        } else {
          viewRangeStartIndex = viewRangeEndIndex - 12
        }
      } else if (!logChartVue.isChangeRangeBarWidth) {
        // レンジバーの幅を変えている場合はそのままのレンジで表示する
        viewRangeStartIndex = viewRangeEndIndex - 12
      }
    }
    option.dataZoom[0].startValue = option.xAxis.data[viewRangeStartIndex].toString()
    option.dataZoom[0].endValue = option.xAxis.data[viewRangeEndIndex].toString()
    logChartVue.range = {
      start: option.xAxis.data[viewRangeStartIndex],
      end: option.xAxis.data[viewRangeEndIndex]
    }
    return option
  }
  // タイムスタンプ値の丸め
  roundTimestamp (logChartVue, timestamp) {
    let dateObj = new Date(timestamp * 1000)

    switch (logChartVue.period) {
      case '15m':
      case '1h':
      case '1d':
        timestamp = timestamp - (timestamp % logChartVue.periodTime)
        break
      case '1w':
        dateObj.setDate(dateObj.getDate() - dateObj.getDay())
        var week = Math.floor(dateObj.getTime() / 1000)
        // 時間を00時になるよう1日の秒数で割、余りを引く
        timestamp = week - (week % 86400)
        break
      case '1M':
        dateObj.setDate(1)
        var month = Math.floor(dateObj.getTime() / 1000)
        // 時間を00時になるよう1日の秒数で割、余りを引く
        timestamp = month - (month % 86400)
        break
    }
    return timestamp
  }
  // 描画範囲のプロットの中間点からのオフセットを取得する
  // 最新表示の場合はプロットの最新からのオフセットを取得する
  getRangePeriodOffsets (logChartVue, isRecent = false) {
    let rangeOffsets = {
      toStart: isRecent ? 12 : 6,
      toEnd: isRecent ? 0 : 6
    }
    const rangePeriods = Math.floor((logChartVue.range.end - logChartVue.range.start) / logChartVue.periodTime)
    // 描画範囲のレンジバーが変更されている場合
    if (logChartVue.isChangeRangeBarWidth) {
      if (isRecent) {
        // 最新ボタン押下時
        rangeOffsets.toStart = rangePeriods
      } else {
        // 移動ボタン押下時
        const rangePeriodMidPoint = Math.ceil(rangePeriods / 2)
        rangeOffsets.toEnd = rangePeriods - rangePeriodMidPoint
        rangeOffsets.toStart = rangePeriods - rangeOffsets.toEnd
      }
    }
    return rangeOffsets
  }
  getRangeByToDatetimePeriod (logChartVue, toDatetimeUnixTime) {
    let jumpToDate = this.roundTimestamp(logChartVue, toDatetimeUnixTime)
    // console.log(new Date(jumpToDate * 1000))
    const rangeOffsets = this.getRangePeriodOffsets(logChartVue)
    let range = {
      start: jumpToDate - (logChartVue.periodTime * rangeOffsets.toStart),
      end: jumpToDate + (logChartVue.periodTime * rangeOffsets.toEnd)
    }
    // 現在時刻
    let now = Math.floor(Date.now() / 1000)
    now = now - (now % (15 * 60))
    const rangeEnd = now - (now % logChartVue.periodTime)
    // ジャンプ日時が最新の範囲に収まらない場合は中心を右にずらす
    if (jumpToDate > (rangeEnd - (logChartVue.periodTime * rangeOffsets.toEnd))) {
      const offset = jumpToDate - (rangeEnd - (logChartVue.periodTime * rangeOffsets.toEnd))
      range.start -= offset
      range.end -= offset
    } else {
      // ジャンプ日時が最古の範囲に収まらない場合は中心を左にずらす
      // 現在時刻
      let createdDateTime = logChartVue.createdDateTime - (logChartVue.createdDateTime % logChartVue.periodTime)
      if (jumpToDate < (createdDateTime + (logChartVue.periodTime * rangeOffsets.toStart))) {
        const offset = (createdDateTime + (logChartVue.periodTime * rangeOffsets.toStart)) - jumpToDate
        range.start += offset
        range.end += offset
      }
    }
    return range
  }
  setMessagePeriodJump (logChartVue, datazoomRange) {
    let jumpToDate = this.roundTimestamp(logChartVue, logChartVue.toDatetimeUnixTime)
    // console.log(new Date(jumpToDate * 1000))
    logChartVue.messagePeriodJump = ''
    // レンジバーを変更した場合はメッセージ表示はしない
    if (logChartVue.isChangedRangeBar) {
      logChartVue.isChangedPeriod = false
      logChartVue.isChangedRangeBar = false
      return
    }
    // ジャンプ日時が最新の範囲に収まらない場合
    const rangeOffsets = this.getRangePeriodOffsets(logChartVue)
    if (jumpToDate > (datazoomRange.end - (logChartVue.periodTime * rangeOffsets.toEnd))) {
      if (jumpToDate > datazoomRange.end) {
        // 日時が範囲外
        logChartVue.messagePeriodJump = logChartVue.$t('chart.message-outbounds-latest')
      } else if (jumpToDate < datazoomRange.end) {
        // 日時が最新6プロット分
        logChartVue.messagePeriodJump = logChartVue.$t('chart.message-latest')
      }
    } else {
      // ジャンプ日時が最古の範囲に収まらない場合
      // 現在時刻
      if (jumpToDate < (datazoomRange.start + (logChartVue.periodTime * rangeOffsets.toStart))) {
        if (jumpToDate < datazoomRange.start) {
          // 日時が範囲外
          logChartVue.messagePeriodJump = logChartVue.$t('chart.message-outbounds-oldest')
        } else {
          // 日時が最新6プロット分
          logChartVue.messagePeriodJump = logChartVue.$t('chart.message-oldest')
        }
      }
    }
    if (logChartVue.isChangedPeriod && logChartVue.messagePeriodJump) {
      logChartVue.showPeriodMessagePeriodJump = true
      setTimeout(() => {
        logChartVue.showPeriodMessagePeriodJump = false
      }, 5000)
    } else if (logChartVue.messagePeriodJump) {
      logChartVue.showJumpMessagePeriodJump = true
      setTimeout(() => {
        logChartVue.showJumpMessagePeriodJump = false
      }, 5000)
    }
    logChartVue.isChangedPeriod = false
  }
  resetDataZoomToolBox (logChartVue) {
    if (logChartVue.myChart.getModel().option.toolbox[0].feature.dataZoom.show) {
      const ecToolBox = logChartVue.myChart.getModel()._componentsMap._ec_toolbox
      let ecToolBoxModel = ecToolBox[0].ecModel
      // ズーム履歴を全部戻す
      while (ecToolBoxModel['\0_ec_hist_store'].length > 1) {
        logChartVue.myChart._api.dispatchAction({
          type: 'datazoom',
          batch: ecToolBoxModel['\0_ec_hist_store'].pop()
        })
      }
      // データリストアも行っておく
      logChartVue.myChart._api.dispatchAction({
        type: 'restore'
      })
      // console.log(ecToolBoxModel)
    }
  }
  // 先頭と末尾のデータ補正のための描画範囲内、描画範囲外のプロット位置の取得
  retrieveFillPlotsRangeDatasets (logChartVue, option, seriesIndex) {
    // 退避したデータを戻す
    option.xAxis.data = JSON.parse(JSON.stringify(logChartVue.xAxisDatas))
    option.series = JSON.parse(JSON.stringify(logChartVue.seriesDatas))
    let viewRangeStartIndex = option.xAxis.data.indexOf(Number(option.dataZoom[0].startValue))
    let viewRangeEndIndex = option.xAxis.data.indexOf(Number(option.dataZoom[0].endValue))
    // 1プロットまでズームした日時が、データがない場合は線を描画させるために1プロット分増やして表示する
    if (logChartVue.isChangeRangeBarWidth && viewRangeEndIndex - viewRangeStartIndex === 0 && option.series[0].data[viewRangeStartIndex] === null) {
      // 新しいデータがある場合は新しい方へ広げる
      if (viewRangeEndIndex < option.xAxis.data.length - 1) {
        viewRangeEndIndex++
      } else if (viewRangeStartIndex > 0) {
        viewRangeStartIndex--
      }
      logChartVue.range = {
        start: option.xAxis.data[viewRangeStartIndex],
        end: option.xAxis.data[viewRangeEndIndex]
      }
      option.dataZoom[0].startValue = option.xAxis.data[viewRangeStartIndex].toString()
      option.dataZoom[0].endValue = option.xAxis.data[viewRangeEndIndex].toString()
    }
    let rangeDatasets = {
      outOfFrom: { // Fromの範囲外
        timestamp: logChartVue.outOfFromTimestamp,
        seriesData: JSON.parse(JSON.stringify(logChartVue.outOfFromSeriesData))
      },
      outOfViewRangeStart: { // 描画範囲のStartの範囲外
        timestamp: null,
        seriesData: []
      },
      oldestViewRange: { // 描画範囲内の最古
        timestamp: null,
        seriesData: []
      },
      latestViewRange: { // 描画範囲内の最新
        timestamp: null,
        seriesData: []
      },
      outOfViewRangeEnd: { // 描画範囲のEndの範囲外
        timestamp: null,
        seriesData: []
      },
      outOfTo: { // toの範囲外
        timestamp: logChartVue.outOfToTimestamp,
        seriesData: JSON.parse(JSON.stringify(logChartVue.outOfToSeriesData))
      }
    }

    // 描画範囲より古いデータのうち、最新のデータ決定
    for (let dataIndex = viewRangeStartIndex - 1; dataIndex >= 0; dataIndex--) {
      if (option.series[seriesIndex].data[dataIndex] !== null) {
        rangeDatasets.outOfViewRangeStart.timestamp = option.xAxis.data[dataIndex]
        option.series.forEach((one, index) => {
          rangeDatasets.outOfViewRangeStart.seriesData[index] = option.series[index].data[dataIndex]
        })
        break
      }
    }
    // 描画範囲内の最古のデータ決定
    for (let dataIndex = viewRangeStartIndex; dataIndex <= viewRangeEndIndex; dataIndex++) {
      if (option.series[seriesIndex].data[dataIndex] !== null) {
        rangeDatasets.oldestViewRange.timestamp = option.xAxis.data[dataIndex]
        option.series.forEach((one, index) => {
          rangeDatasets.oldestViewRange.seriesData[index] = option.series[index].data[dataIndex]
        })
        break
      }
    }
    // 描画範囲内の最新のデータ決定
    for (let dataIndex = viewRangeEndIndex; dataIndex >= viewRangeStartIndex; dataIndex--) {
      if (option.series[seriesIndex].data[dataIndex] !== null) {
        rangeDatasets.latestViewRange.timestamp = option.xAxis.data[dataIndex]
        option.series.forEach((one, index) => {
          rangeDatasets.latestViewRange.seriesData[index] = option.series[index].data[dataIndex]
        })
        break
      }
    }
    // 描画範囲より新しいデータのうち、最古のデータ決定
    for (let dataIndex = viewRangeEndIndex + 1; dataIndex < option.xAxis.data.length; dataIndex++) {
      if (option.series[seriesIndex].data[dataIndex] !== null) {
        rangeDatasets.outOfViewRangeEnd.timestamp = option.xAxis.data[dataIndex]
        option.series.forEach((one, index) => {
          rangeDatasets.outOfViewRangeEnd.seriesData[index] = option.series[index].data[dataIndex]
        })
        break
      }
    }
    // 描画範囲外データの決定
    // * 描画範囲のStartの前のデータ
    // ** fromより前のデータがあって、描画範囲のStartの前がなければ、fromより前のデータを利用
    if (rangeDatasets.outOfFrom.timestamp !== null && rangeDatasets.outOfViewRangeStart.timestamp === null) {
      rangeDatasets.outOfViewRangeStart = JSON.parse(JSON.stringify(rangeDatasets.outOfFrom))
    }
    // * 描画範囲のEndの後のデータ
    // ** toより後のデータがあって、描画範囲のToの後があれば、toより後のデータを利用
    if (rangeDatasets.outOfTo.timestamp !== null && rangeDatasets.outOfViewRangeEnd.timestamp === null) {
      rangeDatasets.outOfViewRangeEnd = JSON.parse(JSON.stringify(rangeDatasets.outOfTo))
    }
    // 最終更新日時(現在時刻から算出)
    let rangeLast = this.roundTimestamp(logChartVue, Math.floor(new Date().getTime() / 1000))
    // 描画範囲のEndの後のデータ、描画範囲内のデータがなく、描画範囲のStartの前のデータがある場合は、
    // 描画範囲のStartの前のデータを描画範囲のEndの後のデータとして利用
    // ただし、タイムスタンプは現在時刻から算出した値を利用
    if (rangeDatasets.oldestViewRange.timestamp === null && rangeDatasets.latestViewRange.timestamp === null &&
      rangeDatasets.outOfViewRangeEnd.timestamp === null && rangeDatasets.outOfViewRangeStart.timestamp !== null
    ) {
      rangeDatasets.outOfViewRangeEnd.timestamp = rangeLast
      rangeDatasets.outOfViewRangeEnd.seriesData = JSON.parse(JSON.stringify(rangeDatasets.outOfViewRangeStart.seriesData))
    }
    // 描画範囲のEndの後のデータがなく描画範囲内の最新のデータがある場合は
    // 描画範囲内の最新のデータを描画範囲のEndの後のデータとして利用
    // ただし、タイムスタンプは現在時刻から算出した値を利用
    if (rangeDatasets.outOfViewRangeEnd.timestamp === null && rangeDatasets.latestViewRange.timestamp !== null
    ) {
      rangeDatasets.outOfViewRangeEnd.timestamp = rangeLast
      rangeDatasets.outOfViewRangeEnd.seriesData = JSON.parse(JSON.stringify(rangeDatasets.latestViewRange.seriesData))
    }

    // console.log(rangeDatasets)
    return {option: option, rangeDatasets: rangeDatasets, viewRangeStartIndex: viewRangeStartIndex, viewRangeEndIndex: viewRangeEndIndex}
  }
}

const graphHelper = new GraphHelper()
export default graphHelper



// WEBPACK FOOTER //
// ./src/utils/graphhelper.js